export default (props, vars) => props?.['name'] === 'flag';
